/* components/ui/Number.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	add_flush_callback,
	bind,
	binding_callbacks,
	create_component,
	destroy_component,
	init,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import Prop from "./Prop.svelte";
import NumberInput from "./dom/NumberInput.svelte";

function create_default_slot(ctx) {
	let numberinput;
	let updating_value;
	let current;

	function numberinput_value_binding(value) {
		/*numberinput_value_binding*/ ctx[9].call(null, value);
	}

	let numberinput_props = {
		fullWidth: /*fullWidth*/ ctx[8],
		draggable: /*draggable*/ ctx[7],
		readonly: /*readonly*/ ctx[5],
		round: /*round*/ ctx[6],
		min: /*min*/ ctx[2],
		max: /*max*/ ctx[3],
		step: /*step*/ ctx[4]
	};

	if (/*value*/ ctx[0] !== void 0) {
		numberinput_props.value = /*value*/ ctx[0];
	}

	numberinput = new NumberInput({ props: numberinput_props });
	binding_callbacks.push(() => bind(numberinput, "value", numberinput_value_binding));

	return {
		c() {
			create_component(numberinput.$$.fragment);
		},
		m(target, anchor) {
			mount_component(numberinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const numberinput_changes = {};
			if (dirty & /*fullWidth*/ 256) numberinput_changes.fullWidth = /*fullWidth*/ ctx[8];
			if (dirty & /*draggable*/ 128) numberinput_changes.draggable = /*draggable*/ ctx[7];
			if (dirty & /*readonly*/ 32) numberinput_changes.readonly = /*readonly*/ ctx[5];
			if (dirty & /*round*/ 64) numberinput_changes.round = /*round*/ ctx[6];
			if (dirty & /*min*/ 4) numberinput_changes.min = /*min*/ ctx[2];
			if (dirty & /*max*/ 8) numberinput_changes.max = /*max*/ ctx[3];
			if (dirty & /*step*/ 16) numberinput_changes.step = /*step*/ ctx[4];

			if (!updating_value && dirty & /*value*/ 1) {
				updating_value = true;
				numberinput_changes.value = /*value*/ ctx[0];
				add_flush_callback(() => updating_value = false);
			}

			numberinput.$set(numberinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(numberinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(numberinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(numberinput, detaching);
		}
	};
}

function create_fragment(ctx) {
	let prop;
	let current;

	prop = new Prop({
			props: {
				label: /*label*/ ctx[1],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(prop.$$.fragment);
		},
		m(target, anchor) {
			mount_component(prop, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const prop_changes = {};
			if (dirty & /*label*/ 2) prop_changes.label = /*label*/ ctx[1];

			if (dirty & /*$$scope, fullWidth, draggable, readonly, round, min, max, step, value*/ 1533) {
				prop_changes.$$scope = { dirty, ctx };
			}

			prop.$set(prop_changes);
		},
		i(local) {
			if (current) return;
			transition_in(prop.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prop.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(prop, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { label = "" } = $$props;
	let { value = 0 } = $$props;
	let { min = undefined } = $$props;
	let { max = undefined } = $$props;
	let { step = undefined } = $$props;
	let { readonly = false } = $$props;
	let { round = true } = $$props;
	let { draggable = true } = $$props;
	let { fullWidth = false } = $$props;

	function numberinput_value_binding(value$1) {
		value = value$1;
		(($$invalidate(0, value), $$invalidate(2, min)), $$invalidate(3, max));
	}

	$$self.$$set = $$props => {
		if ("label" in $$props) $$invalidate(1, label = $$props.label);
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("min" in $$props) $$invalidate(2, min = $$props.min);
		if ("max" in $$props) $$invalidate(3, max = $$props.max);
		if ("step" in $$props) $$invalidate(4, step = $$props.step);
		if ("readonly" in $$props) $$invalidate(5, readonly = $$props.readonly);
		if ("round" in $$props) $$invalidate(6, round = $$props.round);
		if ("draggable" in $$props) $$invalidate(7, draggable = $$props.draggable);
		if ("fullWidth" in $$props) $$invalidate(8, fullWidth = $$props.fullWidth);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*value, min, max*/ 13) {
			$: {
				(value, min, max);
				$$invalidate(0, value = +parseFloat(value));
				if (min != null) $$invalidate(0, value = Math.max(min, value));
				if (max != null) $$invalidate(0, value = Math.min(max, value));
			}
		}
	};

	return [
		value,
		label,
		min,
		max,
		step,
		readonly,
		round,
		draggable,
		fullWidth,
		numberinput_value_binding
	];
}

class Number extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			label: 1,
			value: 0,
			min: 2,
			max: 3,
			step: 4,
			readonly: 5,
			round: 6,
			draggable: 7,
			fullWidth: 8
		});
	}
}

export default Number;